<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 09:31:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-10 12:01:00
-->
<template>
  <div class="job wid100">
    <div class="job-bj">
      <img class="wid100" :src="require('@/assets/images/m/job/bj.png')" alt="" srcset="">
      <div class="job-bj-txt">
        <div class="ui-title">{{ $t('job.title') }}</div>
        <div class="ui-des">{{ $t('job.des') }}</div>
      </div>
    </div>
    <div class="job-content">
      <div class="job-info">
        <div class="job-list-title p-b-30">{{ $t('job.info[0]') }}</div>
        <div class="line"></div>
        <div class="p-t-20">{{ $t('job.info[1]') }}</div>
        <div>{{ $t('job.info[2]') }}</div>
        <div class="fontW p-b-20">{{ $t('job.info[3]') }}</div>
        <div class="line"></div>
        <div class="p-t-10" v-html="$t('job.info[4]')"></div>
        <div v-html="$t('job.info[5]')"></div>
        <div class="fontW p-b-20">{{ $t('job.info[6]') }}</div>
        <div class="line"></div>
        <div class="p-t-10">{{ $t('job.info[7]') }}</div>
        <div class="fontW">{{ $t('job.info[8]') }}</div>
        <div>{{ $t('job.info[9]') }}</div>
      </div>
      <div class="job-welfare">
        <div class="job-list-title p-b-30">{{ $t('job.welfare.title') }}</div>
        <div class="flex align_items_end" v-for="(item, index) in 6" :key="index">
          <div class="flex_1 job-welfare-item" v-for="($item, $index) in 2" :key="$index">
            <img :class="index == 0 && $index == 1 ? 'm-b-3' : ''" :src="$t(`job.welfare.list[${index * 2 + $index}].img`)" alt="" srcset="">
            <div>{{ $t(`job.welfare.list[${index * 2 + $index}].title`) }}</div>
          </div>
        </div>
      </div>
      <div class="job-recruit">
        <div class="job-list-title p-b-20">{{ $t('job.recruit.title') }}</div>
        <!-- <div class="job-recruit-box flex flex_wrap">
          <div :class="['job-recruit-item', item.pending ? 'pending' : '']" v-for="(item, index) in $t('job.recruit.list')" :key="item.id">
            <div v-if="item.pending || item.hot" class="hot">{{item.pending ? $t('job.recruit.pending') : $t('job.recruit.hot')}}</div>
            <div class="title">{{ item.title }} <br />{{ item.des }}</div>
            <div>{{ $t('job.recruit.num') }}： {{ item.num }}</div>
            <div>{{ $t('job.recruit.address') }}： {{ item.address }}</div>
            <div>{{ $t('job.recruit.experience') }}： {{ item.experience }}</div>
            <div>{{ $t('job.recruit.education') }}： {{ item.education }}</div>
            <div class="job-recruit-item-btn" @click="clickLick(index, item.pending)">{{ $t('job.recruit.listMore') }}</div>
          </div>
        </div> -->
        <div class="textc">
          <a class="job-recruit-btn" :href="$t('job.recruit.boss')" target="_blank">{{ $t('job.recruit.more') }} >></a>
        </div>
      </div>
    </div>
    <van-dialog
      ref="jobDialog"
      v-model:show="dialogVisible"
      title=""
      class="job-dialog"
      width="80vw"
      :show-confirm-button="false"
      :close-on-click-overlay="true">
      <div class="job-dialog-body">
        <div>{{ $t('job.recruit.jobDetails') }}</div>
        <div class="position-title">{{ $t(`job.recruit.list[${active}].title`) }}{{ $t(`job.recruit.list[${active}].des`) }}</div>
        <div class="job-dialog-item">
          <div class="flex">
            <div class="flex_1">{{ $t('job.recruit.address') }}：{{ $t(`job.recruit.list[${active}].address`)}}</div>
            <div class="flex_1">{{ $t('job.recruit.jobType') }}：{{ $t(`job.recruit.list[${active}].type`)}}</div>
          </div>
          <div class="flex">
            <div class="flex_1">{{ $t('job.recruit.num') }}：{{ $t(`job.recruit.list[${active}].num`)}}</div>
            <div class="flex_1">{{ $t('job.recruit.updateTime') }}：{{ $t(`job.recruit.list[${active}].time`)}}</div>
          </div>
        </div>
        <div class="job-dialog-main">
          <div class="title">{{ $t('job.recruit.content') }}：</div>
          <div v-for="(item, index) in $t(`job.recruit.list[${active}].content`)" :key="`1_${index}`">{{index + 1}}、{{item}}</div>
          <div class="title">{{ $t('job.recruit.jobRequirements') }}：</div>
          <div v-for="(item, index) in $t(`job.recruit.list[${active}].requirement`)" :key="`2_${index}`">{{index + 1}}、{{item}}</div>
        </div>
        <div class="textc">
          <a class="btn ilblk" :href="$t('job.recruit.boss')" target="_blank">{{ $t('job.recruit.apply') }}</a>
          <a class="btn active ilblk m-l-46" :href="$t('job.recruit.boss')" target="_blank">{{ $t('job.recruit.collect') }}</a>
        </div>
      </div>
      <div class="job-dialog-close center_left_right"  @click="closeDialog"><img :src="require('@/assets/images/m/job/close.png')"></div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'job',
  data () {
    return {
      dialogVisible: false,
      active: 0
    }
  },
  methods: {
    clickLick (index, flag) {
      if (!flag) {
        this.active = index
        this.dialogVisible = true
      }
    },
    // 关闭弹窗
    closeDialog () {
      this.$refs.jobDialog.close()
    }
  }
}
</script>

<style lang="less" scoped>
.m .job {
  color: #333333;
  .job-bj {
    position: relative;
    .job-bj-txt {
      position: absolute;
      right: 30px;
      bottom: 40px;
    }
  }
  .job-content {
    padding: 64px 30px 20px 30px;
    font-size: 24px;
    text-align: center;
    line-height: 50px;
    .job-list-title {
      font-size: 34px;
      font-weight: bold;
      line-height: 48px;
    }
    .job-list-des {
      line-height: 50px;
      opacity: 0.6;
    }
    .job-info {
      padding: 20px 0 52px 0;
      line-height: 50px;
      .line {
        width: 36px;
        height: 1px;
        background: #00A0E9;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 10px;
      }
    }
    .job-welfare {
      padding-top: 30px;
      padding-bottom: 60px;
      font-size: 24px;
      .job-welfare-item {
        line-height: 34px;
        padding: 40px 0;
        img {
          margin-bottom: 20px;
          // width: 40%;
          transform: scale(0.8);
        }
      }
    }
    .job-recruit {
      .job-recruit-box {
        padding-top: 50px;
        .job-recruit-item {
          background: #858E91;
          padding: 50px 46px;
          width: calc( 50% - 15px);
          color: #E2E2E2;
          font-size: 24px;
          line-height: 36px;
          margin-bottom: 30px;
          border-radius: 11px;
          cursor: pointer;
          text-align: left;
          position: relative;
          overflow: hidden;
          &:nth-child(2n + 2) {
            margin-left: 25px;
          }
          &.pending {
            .hot {
              background: rgba(0, 0, 0, 0.1);
              &::before {
                border-right-color: rgba(0, 0, 0, 0.1);
              }
            }
            .job-recruit-item-btn {
              border: 1px solid rgba(226, 226, 226, 0.5);
              color: rgba(226, 226, 226, 0.5);
            }
          }
          .hot {
            position: absolute;
            top: 0;
            right: 0;
            width: 4.6em;
            height: 46px;
            line-height: 46px;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.2);
            padding-left: 0.7em;
            &::before {
              content: '';
              position: absolute;
              border-bottom: 46px transparent dashed;
              border-right: 1em rgba(0, 0, 0, 0.2) solid;
              left: -1em;
              top: 0;
              z-index: 2;
            }
          }
          .title {
            font-size: 32px;
            line-height: 46px;
            color: #ffffff;
            padding-bottom: 30px;
          }
          .job-recruit-item-btn {
            width: 100%;
            height: 60px;
            border: 1px solid #E2E2E2;
            line-height: 58px;
            text-align: center;
            margin-top: 48px;
          }
          &:not(.pending) {
            .job-recruit-item-btn {
              &:hover {
                background: #00A0E9;
                color: #ffffff;
                border-color: #00A0E9;
                box-shadow: 0px 8px 10px 0px rgba(0, 134, 192, 0.28);
              }
            }
          }
        }
      }
      .job-recruit-btn {
        color: #00A0E9;
        font-size: 24px;
        line-height: 52px;
        padding: 0 40px;
        display: inline-block;
        margin: 30px 0;
      }
    }
  }
}
</style>
<style lang="less">
.m .job {
  .job-dialog {
    background-color: transparent;
    overflow: inherit;
    .van-dialog {
      border-radius: 8px;
      background: none;
    }
    .van-dialog__content {
    }
    .job-dialog-body {
      position: relative;
      background: #ffffff;
      padding: 42px 46px 40px 60px;
    }
    .position-title {
      font-size: 24px;
      line-height: 33px;
      padding: 14px 0 7px 0;
    }
    .job-dialog-item {
      font-size: 24px;
      border-bottom: 1px solid rgba(151, 151, 151, 0.2);
      padding-bottom: 25px;
    }
    .job-dialog-main {
      line-height: 34px;
      font-size: 20px;
      max-height: 40vh;
      overflow-y: auto;
      .title {
        font-size: 24px;
        padding: 15px 0;
      }
    }
    .btn {
      width: 200px;
      background: #00A0E9;
      border-radius: 23px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      margin-top: 56px;
      height: 60px;
      font-size: 24px;
      border: 1px solid #E2E2E2;
      line-height: 58px;
      text-align: center;
      margin-top: 48px;
      &.active {
        background: #0054A9;
      }
    }
    .job-dialog-close {
      position: absolute;
      bottom: -100px;
      text-align: center;
      img {
        width: 80px;
      }
    }
  }
}
</style>
